"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var _helpers = require("./helpers");

var _TextField = _interopRequireDefault(require("../../elements/TextField"));

var _CalendarIcon = _interopRequireDefault(require("../../icons/CalendarIcon"));

var _DateRangePickerCard = _interopRequireDefault(require("./DateRangePickerCard"));

require("../common/datepicker.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function isOrContainsNode(parent, child) {
  return parent === child || parent.contains && parent.contains(child);
}

function InlineDateRangePicker(props) {
  var startDate = props.startDate,
      endDate = props.endDate,
      onChange = props.onChange,
      size = props.size,
      selectOptions = props.selectOptions,
      selectedItem = props.selectedItem,
      onChangeSelectedItem = props.onChangeSelectedItem,
      presetRanges = props.presetRanges;
  var wrapperRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)((0, _helpers.rangeToText)(startDate, endDate)),
      _useState2 = _slicedToArray(_useState, 2),
      rangeTextValue = _useState2[0],
      setRangeTextValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isCardOpen = _useState4[0],
      setIsCardOpen = _useState4[1];

  (0, _react.useEffect)(function () {
    setRangeTextValue((0, _helpers.rangeToText)(startDate, endDate));
  }, [startDate, endDate]);
  (0, _react.useEffect)(function () {
    if (isCardOpen && wrapperRef.current) {
      var onMouseUp = function onMouseUp(event) {
        if (!isOrContainsNode(wrapperRef.current, event.target)) {
          setIsCardOpen(false);
        }
      };

      window.addEventListener('mouseup', onMouseUp);
      return function () {
        window.removeEventListener('mouseup', onMouseUp);
      };
    }
  }, [isCardOpen, setIsCardOpen]);
  var handleTextFieldChange = (0, _react.useCallback)(function (e) {
    var fieldValue = e.target.value;
    setRangeTextValue(fieldValue);

    var _textToRange = (0, _helpers.textToRange)(fieldValue),
        _textToRange2 = _slicedToArray(_textToRange, 2),
        newStartDate = _textToRange2[0],
        newEndDate = _textToRange2[1];

    if ((0, _isValid.default)(newStartDate) && (0, _isValid.default)(newEndDate)) onChange(newStartDate, newEndDate);
  }, [setRangeTextValue, onChange]);
  return _react.default.createElement("div", {
    ref: wrapperRef,
    className: "relative"
  }, _react.default.createElement(_TextField.default, {
    value: rangeTextValue,
    onChange: handleTextFieldChange,
    iconSuffix: _react.default.createElement(_CalendarIcon.default, {
      size: size === 'small' ? 20 : 24
    }),
    size: size,
    onFocus: function onFocus() {
      return setIsCardOpen(true);
    }
  }), isCardOpen && _react.default.createElement("div", {
    className: "absolute z-40",
    style: {
      paddingTop: 1
    }
  }, _react.default.createElement(_DateRangePickerCard.default, {
    startDate: startDate,
    endDate: endDate,
    onChange: onChange,
    selectOptions: selectOptions,
    selectedItem: selectedItem,
    onChangeSelectedItem: onChangeSelectedItem,
    presetRanges: presetRanges
  })));
}

InlineDateRangePicker.propTypes = {
  startDate: _propTypes.default.instanceOf(Date).isRequired,
  endDate: _propTypes.default.instanceOf(Date).isRequired,
  onChange: _propTypes.default.func.isRequired,
  size: _propTypes.default.oneOf(['small', 'medium']),
  selectOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  selectedItem: _propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  }),
  onChangeSelectedItem: _propTypes.default.func,
  presetRanges: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    start: _propTypes.default.instanceOf(Date),
    end: _propTypes.default.instanceOf(Date)
  })).isRequired
};
InlineDateRangePicker.defaultProps = {
  size: 'medium'
};
var _default = InlineDateRangePicker;
exports.default = _default;